import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SupplierExceptionModel } from '../../content/after-sales/model/supplier-exceptions-model';
import { completeEndpoint, EndpointPart } from '../../core/global';
import { EndpointService } from '../endpoint/endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class SupplierExceptionsService {
  private readonly http = inject(HttpClient);
  private readonly endpointService = inject(EndpointService);

  public getAllSupplierExceptions(): Observable<SupplierExceptionModel[]> {
    const url: string = this.endpointService.getEndpointUrl(completeEndpoint(EndpointPart.GET_SUPPLIER_EXCEPTIONS));
    return this.http.get<SupplierExceptionModel[]>(url);
  }

  public saveSupplierException(supplierExceptionModel: SupplierExceptionModel, update: boolean): Observable<any> {
    return update
      ? this.updateSupplierException(supplierExceptionModel)
      : this.saveNewSupplierException(supplierExceptionModel);
  }

  public saveNewSupplierException(supplierExceptionModel: SupplierExceptionModel): Observable<any> {
    const url: string = this.endpointService.getEndpointUrl(completeEndpoint(EndpointPart.POST_NEW_SUPPLIER_EXCEPTION));
    return this.http.post<SupplierExceptionModel>(url, supplierExceptionModel);
  }

  public updateSupplierException(supplierExceptionModel: SupplierExceptionModel): Observable<any> {
    const url: string = this.endpointService.getEndpointUrl(completeEndpoint(EndpointPart.PUT_SUPPLIER_EXCEPTION));
    return this.http.put<SupplierExceptionModel>(url, supplierExceptionModel);
  }

  public deleteSupplierException(supplierId: string, exclusionFromDate: Date): Observable<any> {
    const pathParams: Map<string, string | number | boolean | Date> = new Map();
    pathParams.set('supplierId', supplierId);
    pathParams.set('exclusionFromDate', exclusionFromDate);

    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.DELETE_SUPPLIER_EXCEPTION),
      pathParams,
    );
    return this.http.delete<any>(url);
  }
}
